import React from 'react';
import {AbstractReactFactory} from '@projectstorm/react-canvas-core';

import {AbstractNodeModel, AbstractNodeWidget} from "./AbstractNode";
import get from "lodash/get";
import {store} from "../../../../configureStore";
import {withTranslation} from "react-i18next";


class BasketNodeWidget_ extends AbstractNodeWidget {
    constructor(props) {
        super(props);

        this.type = 'basket-node';
    }

    getHeaderClassName() {
        return 'bg-sunny-morning bg-opacity-3';
    }

    getHeader() {
        const options = this.props.node.options;
        return <>
            <i className="pe-7s-cart"> </i> {options.step.name || this.props.t('pages.main.flow_builder.node.basket.name', 'Shopping cart')}
        </>;
    }

    getErrors() {
        const options = this.props.node.options;
        // const text = get(options.step.text, store.getState().Shops.activeShop.lang_by_default);
        const text = options.step.text;
        const imageUrl = options.step.image_url;

        const errors = [];
        if (!text && !imageUrl) {
            errors.push(this.props.t('pages.main.flow_builder.node.basket.error.add_text_or_image', 'Please provide text or image'));
        }

        return errors.map((error, idx) => <div className='py-2' key={idx}>
                <i className='text-danger opacity-9'>{error}</i>
            </div>
        );
    }
}

export const BasketNodeWidget = withTranslation()(BasketNodeWidget_);


export class BasketNodeModel extends AbstractNodeModel {
    constructor(options = {}) {
        super({
            ...options,
            type: 'basket-node',
            disableNextStepPort: true,
        });
    }
}


export class BasketNodeFactory extends AbstractReactFactory {
    constructor() {
        super('basket-node');
    }

    generateModel(event) {
        return new BasketNodeModel();
    }

    generateReactWidget(event) {
        return <BasketNodeWidget engine={this.engine} node={event.model}/>;
    }
}
